<div class="row row--valign-center">
  <div class="column--8">
    <h3>{{ isEditing ? 'Edit' : 'Create' }} Site Hotspot</h3>
  </div>
  <div class="column--4 align-right">
    <button mat-icon-button color="primary" (click)="dismissDrawer()"><mat-icon>close</mat-icon></button>
  </div>
</div>

<form [formGroup]="form" *ngIf="!loading">
  <!-- Basic Information -->
  <div class="row">
    <div class="column--12">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" id="hotspot_name" required />
        <mat-error *ngIf="form.get('name')?.errors?.['required']"> Hotspot name is required </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="column--12">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Page Slug</mat-label>
        <input matInput formControlName="pageSlug" id="pageSlug" required />
      </mat-form-field>
    </div>
  </div>

  <!-- Hotspot Configuration -->
  <div formGroupName="settings">
    <div class="row">
      <div class="column--12">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Target Element</mat-label>
          <input matInput formControlName="target" required />
          <mat-error *ngIf="form.get('settings.target')?.errors?.['required']"> Target element is required </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="column--6">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Position</mat-label>
          <mat-select formControlName="position">
            <mat-option *ngFor="let pos of hotspotPositions" [value]="pos">
              {{ pos | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="column--6">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>zIndex</mat-label>
          <input matInput formControlName="zIndex" />
          <mat-error *ngIf="form.get('zIndex')?.errors?.['required']"> Target element is required </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Icon Configuration -->
    <div formGroupName="icon">
      <h5 class="mt--xs">Hotspot Icon</h5>

      <div class="row">
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Icon Type</mat-label>
            <mat-select formControlName="type">
              <mat-option *ngFor="let type of hotspotIconTypes" [value]="type">
                {{ type | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="column--6">
          <app-icon-dropdown
            *ngIf="form.get('settings.icon.type')?.value === 'site-icon'"
            [value]="form.get('settings.icon.src')?.value"
            (selectionChange)="onHotspotIconSelected($event)"
          ></app-icon-dropdown>
        </div>
      </div>

      <div class="row" *ngIf="form.get('settings.icon.type')?.value === 'site-icon'">
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Color</mat-label>
            <input matInput formControlName="color" type="color" />
            <span class="color-hex">{{ form.get('settings.icon.color')?.value }}</span>
          </mat-form-field>
        </div>
        <div class="column--6"></div>
      </div>

      <div class="row" *ngIf="form.get('settings.icon.type')?.value === 'lottie'">
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Source URL</mat-label>
            <input matInput formControlName="src" />
          </mat-form-field>
        </div>
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Renderer</mat-label>
            <mat-select formControlName="renderer">
              <mat-option value="svg">SVG</mat-option>
              <mat-option value="canvas">Canvas</mat-option>
              <mat-option value="html">HTML</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="form.get('settings.icon.type')?.value === 'image'">
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Source URL</mat-label>
            <input matInput formControlName="src" />
          </mat-form-field>
        </div>
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Alt Text</mat-label>
            <input matInput formControlName="alt" />
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="form.get('settings.icon.type')?.value === 'image'">
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Width (px)</mat-label>
            <input matInput formControlName="width" type="number" />
          </mat-form-field>
        </div>
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Height (px)</mat-label>
            <input matInput formControlName="height" type="number" />
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Offset Configuration -->
    <div formGroupName="offset">
      <h5 class="mt--xs">Hotspot Icon Offset</h5>

      <div class="row">
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>X Offset</mat-label>
            <input matInput formControlName="x" type="number" />
          </mat-form-field>
        </div>
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Y Offset</mat-label>
            <input matInput formControlName="y" type="number" />
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Tooltip Configuration -->
    <div formGroupName="tooltip">
      <h4>Tooltip Configuration</h4>

      <div class="row">
        <div class="column--12">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Content</mat-label>
            <textarea matInput formControlName="content" rows="3" required></textarea>
            <mat-error *ngIf="form.get('settings.tooltip.content')?.errors?.['required']">
              Tooltip content is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Position</mat-label>
            <mat-select formControlName="position">
              <mat-option *ngFor="let pos of tooltipPositions" [value]="pos">
                {{ pos | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Max Width</mat-label>
            <input matInput formControlName="maxWidth" type="number" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Background Color</mat-label>
            <input matInput formControlName="backgroundColor" type="color" />
            <span class="color-hex">{{ form.get('settings.tooltip.backgroundColor')?.value }}</span>
          </mat-form-field>
        </div>
        <div class="column--6">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Text Color</mat-label>
            <input matInput formControlName="textColor" type="color" />
            <span class="color-hex">{{ form.get('settings.tooltip.textColor')?.value }}</span>
          </mat-form-field>
        </div>
      </div>

      <!-- Tooltip Icon Configuration -->
      <div formGroupName="icon">
        <h5 class="mt--xs">Tooltip Icon</h5>

        <div class="row">
          <div class="column--6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Icon Type</mat-label>
              <mat-select formControlName="type">
                <mat-option value="">None</mat-option>
                <mat-option *ngFor="let type of tooltipIconTypes" [value]="type">
                  {{ type | titlecase }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="column--6">
            <app-icon-dropdown
              *ngIf="form.get('settings.tooltip.icon.type')?.value === 'site-icon'"
              [value]="form.get('settings.tooltip.icon.src')?.value"
              (selectionChange)="onTooltipIconSelected($event)"
            ></app-icon-dropdown>
          </div>
        </div>

        <div class="row" *ngIf="form.get('settings.tooltip.icon.type')?.value === 'site-icon'">
          <div class="column--6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Color</mat-label>
              <input matInput formControlName="color" type="color" />
              <span class="color-hex">{{ form.get('settings.tooltip.icon.color')?.value }}</span>
            </mat-form-field>
          </div>
          <div class="column--6"></div>
        </div>

        <div class="row" *ngIf="form.get('settings.tooltip.icon.type')?.value === 'lottie'">
          <div class="column--6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Source URL</mat-label>
              <input matInput formControlName="src" />
            </mat-form-field>
          </div>
          <div class="column--6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Renderer</mat-label>
              <mat-select formControlName="renderer">
                <mat-option value="svg">SVG</mat-option>
                <mat-option value="canvas">Canvas</mat-option>
                <mat-option value="html">HTML</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="form.get('settings.tooltip.icon.type')?.value === 'image'">
          <div class="column--6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Source URL</mat-label>
              <input matInput formControlName="src" />
            </mat-form-field>
          </div>
          <div class="column--6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Alt Text</mat-label>
              <input matInput formControlName="alt" />
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="form.get('settings.tooltip.icon.type')?.value === 'image'">
          <div class="column--6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Width (px)</mat-label>
              <input matInput formControlName="width" type="number" />
            </mat-form-field>
          </div>
          <div class="column--6">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Height (px)</mat-label>
              <input matInput formControlName="height" type="number" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column--12">
        <mat-checkbox
          [checked]="form.get('isActive')?.value === 1"
          (change)="form.get('isActive')?.setValue($event.checked ? 1 : 0)"
        >
          Active
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Form Actions -->
  <div class="row mt--md">
    <div class="column--6">
      <button mat-flat-button color="accent" (click)="dismissDrawer()" [disabled]="isSubmitting">Cancel</button>
    </div>
    <div class="column--6 align-right">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="onSubmit()"
        [disabled]="isSubmitting || form.invalid"
      >
        <mat-spinner *ngIf="isSubmitting" diameter="20" class="spinner-button"></mat-spinner>
        <span>{{ isEditing ? 'Update' : 'Create' }} Hotspot</span>
      </button>
    </div>
  </div>
</form>
